import type { Layout } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR';
import {
    sections,
    singleRow,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR/layoutTypings';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { ActionControlId, MailRibbonGroupId, MailRibbonControlId } from 'owa-ribbon-ids';

export const getMLRInsertTabGroupLayouts = computedFn(
    (group: RibbonGroupId, popoutComposeViewState?: ComposeViewState): Layout[] | undefined => {
        switch (group) {
            case MailRibbonGroupId.Group_Include:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                MailRibbonControlId.AttachFile,
                                popoutComposeViewState
                            ).toString(),
                            getComposeRibbonId(
                                MailRibbonControlId.AttachSig,
                                popoutComposeViewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Tables:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                ActionControlId.InsertTable,
                                popoutComposeViewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Illustrations:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                MailRibbonControlId.Pictures,
                                popoutComposeViewState
                            ).toString(),
                            getComposeRibbonId(
                                MailRibbonControlId.Emojis,
                                popoutComposeViewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Links:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                MailRibbonControlId.ShowLinkDialog,
                                popoutComposeViewState
                            ).toString()
                        )
                    ),
                ];

            default:
                return undefined;
        }
    }
);
